<template>
  <div class="finance-order">
    <div class="ly-card">
      <el-tabs v-model="activeName">
        <el-tab-pane label="订单批量查询" name="all">
          <ul class="list">
            <li>
              <div class="title">交易时间</div>
              <div class="content flex-1">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <el-button
                type="text"
                @click.native="changeMore"
                :icon="isMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              >{{ isMore ? '收起' : '更多条件'}}</el-button>
              <el-button type="primary" @click.native="search">查询</el-button>
              <el-button type="primary" @click.native="exportExcel">导出</el-button>
            </li>
            <template v-if="isMore">
              <li>
                <div class="title">订单归属</div>
                <div class="content">
                  <remote-search :options="org_id" @input="value => levelChange(value, 'org_id')" />
                  <remote-search
                    :options="profession_id"
                    :paramsData="professionP"
                    @input="value => levelChange(value, 'profession_id')"
                    ref="profession_id"
                  />
                  <remote-search
                    :options="class_id"
                    :paramsData="classP"
                    @input="value => levelChange(value, 'class_id')"
                    ref="class_id"
                  />
                </div>
              </li>
              <li>
                <div class="title">支付方式</div>
                <div class="content">
                  <el-checkbox-group v-model="form.pay_type">
                    <el-checkbox :label="item.value" v-for="item in payType" :key="item.value" border>{{item.label}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </li>
              <li>
                <div class="title">商品类型</div>
                <div class="content">
                  <el-checkbox-group v-model="form.object_type">
                    <el-checkbox :label="item.value" v-for="item in objectType" :key="item.value" border>{{item.label}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </li>
              <li>
                <div class="title">订单状态</div>
                <div class="content">
                  <el-checkbox-group v-model="form.order_status">
                    <el-checkbox :label="item.value" v-for="item in payStatus" :key="item.value" border>{{item.label}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </li>
            </template>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="按订单号查询" name="one">
          <span class="p-r-10">订单号</span>
          <el-input placeholder="订单号" v-model="form.order_number"></el-input>
          <el-button type="primary" @click.native="search">查询</el-button>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
        class="width-full"
      >
<!--        <template v-slot:reservation_number="row">-->
<!--          <el-button type="text" class="reservation-number" size="small" @click="() => openInf(row)">{{-->
<!--              row.reservation_number-->
<!--            }}</el-button>-->
<!--        </template>-->
        <template v-slot:action="row">
          <el-button @click.native="detail(row)" type="primary" size="mini">详情</el-button>
        </template>
      </ly-table>
    </div>
    <order-inf-list :defData="defData" ref="orderInfo"></order-inf-list>
    <pay-detail
      ref="payDetail"
      :sign_up_id="defData.signup_id"
      :def="defData"
      :class_id="defData.class_id"
      :contact_id="defData.contact_id"
      :keep_reserved="defData.keep_reserved"
      :buttons="buttons"
      @success="search"
    />
  </div>
</template>
<script>
import {
  Checkbox, CheckboxGroup, DatePicker, Input, Tabs, TabPane
} from 'element-ui';
import LyTable from '@/components/LyTable';
import OrderInfList from '@/components/OrderInfList';
import { financeOrderTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import RemoteSearch from '@/components/common/RemoteSearch';
import { org_id, specialized_subject_id, class_id_org } from '@/utils/formConfigCommon';
import utils from '@/utils/utils';
import PayDetail from '@/components/PayDetailOrder';

export default {
  name: 'FinanceOrder',
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ElDatePicker: DatePicker,
    ElCheckbox: Checkbox,
    ElCheckboxGroup: CheckboxGroup,
    ElInput: Input,
    LyTable,
    OrderInfList,
    RemoteSearch,
    PayDetail
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      activeName: 'all',
      date: '',
      form: {
        org_id: '',
        profession_id: '',
        class_id: '',
        object_type: [],
        order_status: [],
        pay_type: [],
        order_number: ''
      },
      isMore: false,
      getTableData: finance.getOrderList,
      searchFormData: {},
      tableHeader: financeOrderTable,
      defData: {},
      org_id: {
        ...org_id.options,
        key: 'fee_level_id',
        clearable: true
      },
      profession_id: {
        ...specialized_subject_id.options,
        key: 'profession_id',
        clearable: true,
        disabled: false
      },
      class_id: {
        ...class_id_org.options,
        key: 'class_id',
        clearable: true,
        disabled: false
      },
      payType: [],
      objectType: [],
      payStatus: []
    };
  },
  mounted() {
    this.search();
    this.init();
  },
  computed: {
    professionP() {
      return {
        org_id: this.form.org_id
      };
    },
    classP() {
      return {
        org_id: this.form.org_id,
        profession_id: this.form.profession_id
      };
    }
  },
  methods: {
    init() {
      finance.getPayType().then(res => {
        if (res) this.payType = res.data;
      });
      finance.getObjectType().then(res => {
        if (res) this.objectType = res.data;
      });
      finance.getPayStatus().then(res => {
        if (res) this.payStatus = res.data;
      });
    },
    exportExcel() {
      finance.exportOrder({
        params: this.searchFormData
      }).then(data => {
        if (data) utils.downloadData(data, '订单列表');
      });
    },
    search() {
      if (this.activeName === 'all') {
        let tmp = {};
        if (this.date && this.date.length) {
          const [first_time, last_time] = this.date;
          tmp = {
            first_time,
            last_time
          };
        }
        this.searchFormData = {
          ...tmp,
          ...this.form
        };
      } else {
        this.searchFormData = {
          order_number: this.form.order_number
        };
      }
      this.$refs.lyTable.setData();
    },
    changeMore() {
      this.isMore = !this.isMore;
      this.$nextTick(() => {
        if (this.$refs.lyTable) this.$refs.lyTable.setMaxHeight();
      });
    },
    detail(row) {
      this.$refs.orderInfo.open();
      finance
        .orderDetail({
          id: row.id
        })
        .then(res => {
          if (res && res.data) {
            this.defData = res.data.detail;
          }
        });
    },
    levelChange(value, key) {
      this.form[key] = value;
      if (key === 'org_id') {
        this.$refs.profession_id.clear();
        this.$refs.class_id.clear();
      }
      if (key === 'profession_id') {
        this.$refs.class_id.clear();
      }
    },
    openInf(row) {
      console.log('row---', row);
      this.defData = { ...row };
      this.$refs.payDetail.open();
    }
  }
};
</script>
<style lang="less">
.finance-order {
  .el-input {
    width: 220px;
    margin-right: 20px;
  }
  ul.list {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      margin: 15px 0;
      display: flex;
      align-items: center;
      .title {
        margin-right: 20px;
      }
    }
  }
  .right {
    float: right;
  }
  .ly-search-comp {
    display: inline-block;
  }
}
</style>
